import React from 'react';
import { Home, Tag, BookOpen, Users } from 'lucide-react';
export function IntentLinks() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-110">
      <h2 className="text-2xl font-serif text-brand-dark mb-6 text-center" data-id="element-111">
        How can Krystle help?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-112">
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-113">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-114">
            <Tag size={22} data-id="element-115" />
          </div>
          <div data-id="element-116">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-117">
              Selling a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-118">
              Inland Empire seller specialist · Five Star Agent
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-119">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-120">
            <Home size={22} data-id="element-121" />
          </div>
          <div data-id="element-122">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-123">
              Buying a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-124">
              Redlands, Yucaipa, Highland & beyond
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-125">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-126">
            <BookOpen size={22} data-id="element-127" />
          </div>
          <div data-id="element-128">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-129">
              Real Estate Planning
            </p>
            <p className="text-sm text-brand-muted" data-id="element-130">
              Certified Real Estate Planner — long-term strategy
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-131">

          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-132">
            <Users size={22} data-id="element-133" />
          </div>
          <div data-id="element-134">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-135">
              Join Our Team
            </p>
            <p className="text-sm text-brand-muted" data-id="element-136">
              Interested in joining the Roth Real Estate Group?
            </p>
          </div>
        </a>
      </div>
    </section>;
}